import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from './instance'

export default class StdClassTypeService {
  static async stdGetTreeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/query_by_dynamic_column?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getTreeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/query_by_dynamic_column?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getTreeListNew(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/get_class_dynamic_group?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取参考数据管理实体树
  static async getDicClassTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdReferenceData/get_class_dynamic_group?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
}
